export const TableFormCellType = Object.freeze({
    InputField: 'inputField',
    Buttons: 'buttons',
    Text: 'text',
    DownloadLink: 'downloadLink',
    BoolFlag: 'boolFlag',
    DownloadMultipleFiles: 'downloadMultipleFiles',
});
